import request from '@/utils/request'
import { Toast, Dialog } from 'vant';

// 
export function getMenu(params) {
    return request({
        url: '/api/system/menu/layout/index',
        method: 'get',
        params
    })
}

export function getInfo(params) {
    return request({
        url: '/getInfo',
        method: 'get',
        params
    })
}


export function getCount(params) {
    return request({
        url: '/api/todo/list/count',
        method: 'get',
        params
    })
}

export function getExistsNotStarted(params) {
    return request({
        url: '/api/trip/existsNotStarted',
        method: 'get',
        params
    })
}
export function getTypeByKey(params) {
    return request({
        url: '/system/data/getTypeByKey',
        method: 'get',
        params
    })
}

export function getRecordList(params) {
    return request({
        url: '/api/system/car/record/getRecordList',
        method: 'get',
        params
    })
}

export function getFieldFormGroupInfo(params) {
    return request({
        url: '/api/system/fieldForm/getFieldFormGroupInfo',
        method: 'get',
        params
    })
}

export function getFreedomCarDeptTree(params) {
    return request({
        url: '/api/tree/freedomCarDeptTree',
        method: 'get',
        params
    })
}


export function getSearchTree(params) {
    return request({
        url: '/api/vehicle/alias/v24',
        method: 'get',
        params
    })
}

export function getBindVehicleInfo(params) {
    return request({
        url: '/api/user/getBindVehicleInfo',
        method: 'get',
        params
    })
}

export function commonUpload(data) {
    return request({
        url: '/common/oss/upload',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data
    })
}


export function BMPGL() {
    return new Promise(function(resolve, reject) {
      window.init = function() {
        setTimeout(() => {
          resolve(window.BMap)
        }, 1000);
      }
      if(!window.BMap){
          const script = document.createElement('script')
          script.type = 'text/javascript'
          script.src = 'https://api.map.baidu.com/api?v=3.0&ak='+process.env.VUE_APP_BMAP_KEY+'&callback=init'
          script.onerror = reject
          document.head.appendChild(script)
      }else{
        resolve(window.BMap)
      }
    })
  }
export function getLocation(isShowloading=true) {
    let loadingInstance = isShowloading ? Toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
    }) : null;
    return new Promise(function (resolve, reject) {
        // const win = window;
        // win.BMplaceFn = function (r) {
        //     resolve(r);
        // };
        // const script = document.createElement("script");
        // script.type = "text/javascript";
        // script.src = `https://api.map.baidu.com/location/ip?ak=${process.env.VUE_APP_BMAP_WEB_KEY}&coor=bd09ll&callback=BMplaceFn`;
        // script.onerror = reject;
        // document.head.appendChild(script);
        
        BMPGL().then((BMap) => {
            let geolocation = new BMap.Geolocation();
            geolocation.getCurrentPosition(function (position) {
                isShowloading && loadingInstance.clear();
                if(this.getStatus() == BMAP_STATUS_SUCCESS){
                    let data = {
                        ...position
                    }
                    if(position.address){
                        data.addressStr = position.address?.province + position.address?.city + position.address?.district + position.address?.street
                    }
                    resolve(data)
                } else {
                    reject('获取定位失败')
                }
            }, { enableHighAccuracy: true });
        })

    });
}

export function drivingByFieldForm(data) {
    return request({
        url: '/api/system/car/record/drivingByFieldForm',
        method: 'post',
        data
    })
}
export function getDrivingLocationDetail(params) {
    return request({
        url: '/api/system/car/record/getDrivingLocationDetail',
        method: 'get',
        params
    })
}

export function getPdDriver(params) {
    return request({
        url: '/api/trip/getPdDriver',
        method: 'get',
        params
    })
}

export function getPdDriverSetting(params) {
    return request({
        url: '/api/trip/getPdDriverSetting',
        method: 'get',
        params
    })
}
export function receivingByFieldForm(data) {
    return request({
        url: '/api/system/car/record/receivingByFieldForm',
        method: 'post',
        data
    })
}

export function getReceivingTrackDetail(params) {
    return request({
        url: '/api/system/car/record/getReceivingTrackDetail',
        method: 'get',
        params
    })
}

export function getReceivingTrackList(params) {
    return request({
        url: '/api/system/car/record/getReceivingTrackList',
        method: 'get',
        params
    })
}

export function getTripList(params) {
    return request({
        url: '/api/trip/list',
        method: 'get',
        params
    })
}
export function getTripDetail(params) {
    return request({
        url: '/api/trip/detail',
        method: 'get',
        params
    })
}
export function getApplyListData(params) {
    return request({
        url: '/api/system/useCar/getApplyListData',
        method: 'get',
        params
    })
}
export function getSuggestion(data) {
    return new Promise(function (resolve, reject) {
        const win = window;
        win.SuggestionFn = function (r) {
            resolve(r);
        };
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = `https://api.map.baidu.com/place/v2/suggestion?ak=${process.env.VUE_APP_BMAP_WEB_KEY}&query=${data}&output=json&region=全国&coor=bd09ll&callback=SuggestionFn`;
        script.onerror = reject;
        document.head.appendChild(script);
    });
}

export function searchPlace(data) {
    return new Promise(function (resolve, reject) {
        const win = window;
        win.spFn = function (r) {
            resolve(r);
        };
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = `https://api.map.baidu.com/place/v2/search?ak=${process.env.VUE_APP_BMAP_WEB_KEY}&query=${data.query}&location=${data.location}&radius=${data.radius}&output=json&coor=bd09ll&callback=spFn`;
        script.onerror = reject;
        document.head.appendChild(script);
    });
}

export function getNonePermissionPdDriver(params) {
    return request({
        url: '/api/trip/getNonePermissionPdDriver',
        method: 'get',
        params
    })
}

export function getBindInfo(params) {
    return request({
        url: '/api/system/useCar/getBindInfo/'+params.id+'/2',
        method: 'get',
        params
    })
}
export function getUseCarFieldVisibility(params) {
    return request({
        url: '/api/system/useCar/getUseCarFieldVisibility/'+params,
        method: 'get',
    })
}
export function getAuditFlowData(params) {
    return request({
        url: '/api/system/useCar/getAuditFlowData',
        method: 'get',
        params
    })
}

export function getWkFlowApplyInfo(params) {
    return request({
        url: '/api/activiti/wk/flow/task/getWkFlowApplyInfo',
        method: 'get',
        params
    })
}

export function isFlow(params) {
    return request({
        url: '/activiti/wk/flow/isFlow',
        method: 'get',
        params
    })
}

export function getWrappedUserDataTree(params) {
    return request({
        url: '/system/tree/getWrappedUserDataTree',
        method: 'get',
        params
    })
}

export function addUseCarApproval(data) {
    return request({
        url: '/api/system/useCar/addUseCarApproval',
        method: 'post',
        headers: {
           'Content-Type': 'application/x-www-form-urlencoded'
        },
        data
    })
}

export function revokeApply(data) {
    return request({
        url: '/api/system/useCar/revokeApply',
        method: 'post',
        data
    })
}
export function getApproveDetail(params) {
    return request({
        url: '/api/system/useCar/getApproveDetail/v26',
        method: 'get',
        params
    })
}
export function getFlowApplyNodeDetailInfo(params) {
    return request({
        url: '/activiti/wk/flow/getFlowApplyNodeDetailInfo',
        method: 'get',
        params
    })
}

export function getTrip(params) {
    return request({
        url: '/api/trip/list',
        method: 'get',
        params
    })
}

export function getPdName(params) {
    return request({
        url: '/api/trip/getPdName',
        method: 'get',
        params
    })
}
export function getYcInfo(params) {
    return request({
        url: '/api/trip/getYcInfo',
        method: 'get',
        params
    })
}
export function getIsConflict(params) {
    return request({
        url: '/api/trip/getIsConflict',
        method: 'get',
        params
    })
}

export function carDeptTree(params) {
    return request({
        url: '/api/tree/carDeptTree',
        method: 'get',
        params
    })
}

export function addOrEdit(data) {
    return request({
        url: '/api/trip/addOrEdit',
        method: 'post',
        headers: {
           'Content-Type': 'application/x-www-form-urlencoded'
        },
        data
    })
}


export function sendNotice(data) {
    return request({
        url: '/api/trip/notice',
        method: 'post',
        headers: {
           'Content-Type': 'application/x-www-form-urlencoded'
        },
        data
    })
}

export function deleteTrip(data) {
    return request({
        url: '/api/trip/delete',
        method: 'post',
        headers: {
           'Content-Type': 'application/x-www-form-urlencoded'
        },
        data
    })
}

export function pdTripLog(params) {
    return request({
        url: '/api/trip/pdTripLog',
        method: 'get',
        params
    })
}
export function getApplyMyTask(params) {
    return request({
        url: '/api/system/useCar/getApplyMyTask',
        method: 'get',
        params
    })
}
export function cancelApply(data) {
    return request({
        url: '/api/system/useCar/cancelApply',
        method: 'post',
        data
    })
}

export function putTogether(params) {
    return request({
        url: '/api/system/useCar/putTogether/'+params.acpplyIds+'/'+params.driverId+'/'+params.vehicleId,
        method: 'get',
        params
    })
}
export function dispatchApplyNew(data) {
    return request({
        url: '/api/system/useCar/dispatchApplyNew',
        method: 'post',
        data
    })
}

export function delApproveNew(data) {
    return request({
        url: '/api/system/useCar/delApproveNew',
        method: 'post',
        data
    })
}
export function searchTreeAndVehicleLocation(params) {
    return request({
        url: '/car/location/searchTreeAndVehicleLocation',
        method: 'get',
        params
    })
}

export function getLocationDetail(params) {
    return request({
        url: '/basic/vehicle/ext/info/location/'+params.id,
        method: 'get',
        params
    })
}
export function getTrack(params) {
    return request({
        url: '/system/datainfo/track',
        method: 'get',
        params
    })
}

export function deviceLogin(data) {
    return request({
        url: '/deviceLogin',
        method: 'post',
        data
    })
}
export function updatePwd(data) {
    return request({
        url: '/system/user/profile/updatePwd',
        method: 'post',
        data
    })
}
export function logout(params) {
    return request({
        url: '/logout',
        method: 'get',
        params
    })
}
export function sendCode(data) {
    return request({
        url: '/sms/code',
        method: 'post',
        data
    })
}

export function smsLogin(data) {
    return request({
        url: '/sms/login',
        method: 'post',
        data
    })
}

export function getDeptsHasCars(data) {
    return request({
        url: '/api/tree/getDeptsHasCars',
        method: 'post',
        data
    })
}

export function orderList(params) {
    return request({
        url: '/api/userCar/order/orderList',
        method: 'get',
        params
    })
}
export function getPdSetting(params) {
    return request({
        url: '/api/userCar/order/getPdSetting',
        method: 'get',
        params
    })
}
export function selectSysUseCarOrderByApplyId(params) {
    return request({
        url: '/api/userCar/order/selectSysUseCarOrderByApplyId',
        method: 'get',
        params
    })
}
export function updateAcceptStatus(data) {
    return request({
        url: '/api/userCar/order/updateAcceptStatus',
        method: 'post',
        data
    })
}
export function reportPoint(data) {
    return request({
        url: '/api/useCar/gps/reportPoint',
        method: 'post',
        data
    })
}
export function updateConfirmStatus(data) {
    return request({
        url: '/api/userCar/order/updateConfirmStatus',
        method: 'post',
        data
    })
}
export function checkSiteRange(params) {
    return request({
        url: '/api/userCar/order/checkSiteRange',
        method: 'get',
        params
    })
}

export function checkDriverRange(params) {
    return request({
        url: '/api/userCar/order/checkDriverRange',
        method: 'get',
        params
    })
}
export function getFeeDetailByApplyId(params) {
    return request({
        url: '/api/userCar/order/getFeeDetailByApplyId',
        method: 'get',
        params
    })
}

export function getDrivingFaultFeedbackInfo(params) {
    return request({
        url: '/api/system/car/record/getDrivingFaultFeedbackInfo',
        method: 'get',
        params
    })
}
export function forcedOff(data) {
    return request({
        url: '/api/userCar/order/forcedOff',
        method: 'post',
        data
    })
}

export function getOnCarTime(params) {
    return request({
        url: '/api/userCar/order/getOnCarTime',
        method: 'get',
        params
    })
}